.redux-container-spacing {
    select,
    .select_wrapper {
        width: 80px !important;
        float: left;
    }

    .field-spacing-input {
        margin-right: 10px;
        margin-bottom: 7px;
    }
}

@media screen and (max-width: 782px) {
    .redux-container-spacing {
        .field-spacing-input {
            input {
                display: inline-block !important;
                width: 70px !important;
            }

            .add-on {
                padding: 7px 4px;
                font-size: 16px;
                line-height: 1.5;
            }
        }

        .select_wrapper {
            margin-top: 6px;
        }
    }
}
